import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { OutlinedButton } from '@ds/react-components';
import { Grid } from '@material-ui/core';
import permissionTypes from 'constants/permissionTypes';

const styles = (theme) => ({
  root: {},
  actionButton: {
    marginRight: '16px',
    marginTop: '25px',
    marginBottom: '15px',
  },
});

const CustomerActions = (props) => {
  const { classes, permissions, adfitNo, customerDetails } = props;

  return (
    <Grid container direction="row" justify="flex-end" spacing={2}>
      {permissions.includes('CanTransferAccount') && (
        <Link to={`/Customers/${adfitNo}/Variations`}>
          <OutlinedButton
            variant="secondary"
            classes={{ root: classes.actionButton }}>
            {'Transfer Account'}
          </OutlinedButton>
        </Link>
      )}
      {(permissions.includes(permissionTypes.isAdmin) ||
        (permissions.includes(permissionTypes.canManageVariations) &&
          permissions.includes(permissionTypes.canManageSuspensions))) && (
        <Link to={`/Customers/${adfitNo}/Variations`}>
          <OutlinedButton
            variant="secondary"
            classes={{ root: classes.actionButton }}>
            {'Suspend Account'}
          </OutlinedButton>
        </Link>
      )}
      {permissions.includes(permissionTypes.canManageVariations) &&
        (permissions.includes(permissionTypes.canCancelAllAccounts) ||
          permissions.includes(permissionTypes.canSetToTerm)) &&
        customerDetails &&
        customerDetails.isActive && (
          <Link to={`/Customers/${adfitNo}/Overview/AccountCancellation`}>
            <OutlinedButton
              variant="warning"
              classes={{ root: classes.actionButton }}>
              {'Cancel Account'}
            </OutlinedButton>
          </Link>
        )}
    </Grid>
  );
};

CustomerActions.propTypes = {
  classes: PropTypes.object.isRequired,
  permissions: PropTypes.array.isRequired,
  adfitNo: PropTypes.string.isRequired,
  customerDetails: PropTypes.object.isRequired,
};

export default withStyles(styles)(CustomerActions);
